import { Path } from 'slate';
import { cloneDeep } from 'lodash';
import { defineTransform } from '../transform';
import {
  pathWasRemoved,
  adjustPath,
  adjustPathForNodeSplit,
  adjustPathForNodeMerge,
  adjustNodePathForNodeMove,
  adjustPathForNodeInsert,
  adjustPathForNodeRemove,
} from '../utils';

defineTransform('set_node', 'insert_text', (op1, op2, side) => op1);
defineTransform('set_node', 'remove_text', (op1, op2, side) => op1);
defineTransform('set_node', 'split_node', (op1, op2, side) => {
  if (Path.equals(op1.path, op2.path)) {
    return [
      op1,
      {
        ...cloneDeep(op1),
        path: adjustPath(op1.path, 1, op1.path.length - 1),
      },
    ];
  }

  return {
    ...cloneDeep(op1),
    path: adjustPathForNodeSplit(op1.path, -1, op2, side === 'left'),
  };
});

defineTransform('set_node', 'merge_node', (op1, op2, side) => {
  if (Path.equals(op1.path, op2.path)) return;

  return {
    ...cloneDeep(op1),
    path: adjustPathForNodeMerge(op1.path, op2),
  };
});

defineTransform('set_node', 'move_node', (op1, op2, side) => {
  return {
    ...cloneDeep(op1),
    path: adjustNodePathForNodeMove(op1.path, op2),
  };
});

defineTransform('set_node', 'insert_node', (op1, op2, side) => {
  return {
    ...cloneDeep(op1),
    path: adjustPathForNodeInsert(op1.path, op2, true),
  };
});

defineTransform('set_node', 'remove_node', (op1, op2, side) => {
  if (pathWasRemoved(op1.path, op2.path)) return;
  return {
    ...cloneDeep(op1),
    path: adjustPathForNodeRemove(op1.path, op2),
  };
});

defineTransform('set_node', 'set_node', (op1, op2, side) => {
  if (!Path.equals(op1.path, op2.path)) return op1;

  let newProperties;
  if (side === 'left') {
    newProperties = {
      ...op2.newProperties,
      ...op1.newProperties,
    };
  } else {
    newProperties = {
      ...op1.newProperties,
      ...op2.newProperties,
    };
  }

  return {
    ...cloneDeep(op1),
    newProperties: newProperties,
  };
});

defineTransform('set_node', 'add_mark', (op1, op2, side) => op1);
defineTransform('set_node', 'remove_mark', (op1, op2, side) => op1);
defineTransform('set_node', 'set_mark', (op1, op2, side) => op1);
defineTransform('set_node', 'add_annotation', (op1, op2, side) => op1);
defineTransform('set_node', 'remove_annotation', (op1, op2, side) => op1);
defineTransform('set_node', 'set_annotation', (op1, op2, side) => op1);
defineTransform('set_node', 'set_selection', (op1, op2, side) => op1);
defineTransform('set_node', 'add_metadata', (op1, op2, side) => op1);
defineTransform('set_node', 'remove_metadata', (op1, op2, side) => op1);
defineTransform('set_node', 'set_metadata', (op1, op2, side) => op1);
